import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Log, LogTag} from '../../services/Log';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";

@Component({
  selector: 'app-rich-text',
  template: '<div #component></div>',
  styleUrls: []
})
export class RichTextComponent extends PlayerBase {
  htmlLayer:HTMLElement;
  divElm:HTMLDivElement;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        const globalPos = this.getGlobalPos();
        this.htmlLayer = document.getElementsByName('htmlLayer')[0];
        this.divElm = document.createElement('div');
        this.divElm.style.position = "absolute";
        this.divElm.style.left = globalPos.x + 'px';
        this.divElm.style.top = globalPos.y + 'px';
        this.divElm.style.width = this.actualWidth + 'px';
        this.divElm.style.height = this.actualHeight + 'px';
        this.htmlLayer.appendChild(this.divElm);
        let result = '';
        const str: string = this.data.Text[0]._;

        let fonts = {};

        let count = 0;
        let i1 = 0, i2 = 0, i3 = 0, i4 = 0;
        while (true) {
          i2 = str.indexOf('<FONT', i1);
          if (i2 === -1) {
            result += str.substring(i1);
            break;
          }
          i3 = str.indexOf('>', i2);
          result += str.substring(i1, i2);


          let font: string = str.substring(i2 + 6, i3);
          i1 = i3;

          const a1 = font.indexOf('FACE="');
          const a2 = font.indexOf('"', a1 + 6);
          const face = font.substring(a1 + 6, a2);

          const a3 = font.indexOf('SIZE="', a2);
          const a4 = font.indexOf('"', a3 + 6);
          const size = font.substring(a3 + 6, a4);

          const a5 = font.indexOf('COLOR="', a4);
          const a6 = font.indexOf('"', a5 + 7);
          const color = font.substring(a5 + 7, a6);

          const style = '<FONT style="font-family:' + face + 'normalnormal; font-size:' + size + 'px; color:' + color + ';"';
          result += style;


          if (face != '' && fonts[face] == null) {
            fonts[face] = {
              fontColor: 0,
              fontSize: '',
              fontFamily: face,
              fontWeight: 'normal',
              fontStyle: 'normal',
              autoScaling: ''
            };
            count++;
          }

        }

        for (let key in fonts) {
          const f = fonts[key];
          this.playerService.caching.requestFont(f).subscribe(() => {
            count--;
            if (count == 0) {
              this.divElm.innerHTML = result;
            }
          })
        }
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  destroy(): void {
    /*
    if (this.divElm!=null) {
      this.htmlLayer.removeChild(this.divElm);
    }

     */
    super.destroy();
  }
}
